import { render, staticRenderFns } from "./ClientCollections.vue?vue&type=template&id=3e35bf4e"
import script from "./ClientCollections.vue?vue&type=script&lang=js"
export * from "./ClientCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports